export default "__VITE_ASSET__ae26c39f__"